export default __webpack_public_path__ + "static/media/HN.3ced694a.svg";